import { useDispatch, useSelect } from '@wordpress/data'
import { SelectedServices } from '../../../components/SelectedServices/SelectedServices'
import { store_name } from '../../../../store/frontend'
import { useLayoutEffect, useRef } from 'react'
import { useBookingContext } from '../../../providers/BookingFormProvider/BookingFormProvider'
import { CustomScroll } from 'react-custom-scroll'
import './Steps.scss'
import { constructField } from '../../../components/Form/utils'
import { IFieldConfig } from '../../../components/Form/types'
import { extractFormValue } from '../../../providers/BookingFormProvider/utils'

export const CalendarStep = () => {
    const { services, setFormObj, formData, setFormData } = useBookingContext()
    const selectedServices = services.filter(({ selected }) => selected)
    const { fetchBookingFields, fetchPaymentMethods } = useDispatch(store_name)
    // booking form fields
    const fieldsFetched = useRef(false)
    const bookingFields = useSelect(
        (select: any) =>
            select(store_name).getBookingFields(
                services.filter(({ selected }) => selected).map(({ id }) => id)
            ),
        []
    )

    // fetch booking form fields
    useLayoutEffect(() => {
        if (fieldsFetched.current && bookingFields.length > 0) {
            return
        }

        if (selectedServices.length === 0) {
            return
        }

        fetchBookingFields(selectedServices.map(({ id }) => id))

        fieldsFetched.current = true
    }, [selectedServices])

    useLayoutEffect(() => {
        const enhancedFields =
            bookingFields.length === 0 ? [] : bookingFields.map(constructField)

        setFormObj(
            'fields',
            enhancedFields.map((field: IFieldConfig) => {
                return {
                    ...field,
                    value:
                        extractFormValue({
                            fieldName: field.slug,
                            formData,
                        }) || field.defaultValue,
                }
            })
        )
    }, [bookingFields])

    // payment methods
    const paymentsFetched = useRef(false)
    const paymentMethods = useSelect(
        (select: any) =>
            select(store_name).getPaymentMethods(
                selectedServices.map(({ id }) => id)
            ),
        []
    )

    // fetch payment methods
    useLayoutEffect(() => {
        if (paymentsFetched.current) {
            return
        }

        const serviceIds = selectedServices.map(({ id }) => id)

        if (serviceIds.length === 0) {
            return
        }

        fetchPaymentMethods(serviceIds)

        paymentsFetched.current = true
    }, [selectedServices])

    useLayoutEffect(() => {
        if (paymentMethods.length === 1) {
            setFormData('payment_method', paymentMethods[0].id)
        }

        setFormObj(
            'paymentMethods',
            paymentMethods.length === 0 ? [] : paymentMethods
        )
    }, [paymentMethods])

    return (
        <CustomScroll flex="1" className={'wbk_step__scroll-wrapper'}>
            <div>
                <SelectedServices />
            </div>
        </CustomScroll>
    )
}
